const DRAFT = 'Draft';
const REJECTION_ACKNOWLEDGED = 'Rejection Acknowledged';
const IN_PROGRESS = "in_progress";
const PENDING = "pending"


export {
  DRAFT,
  REJECTION_ACKNOWLEDGED,
  IN_PROGRESS,
  PENDING
};
